import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services';

@Component({
  selector: 'app-verify-user',
  templateUrl: './verify-user.component.html',
  styleUrls: ['./verify-user.component.scss']
})
export class VerifyUserComponent implements OnInit {
  token: string;
  result: boolean;
  language: string;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const userLanguage = window.navigator.language;
    this.language = userLanguage.split('-')[0];
    this.token = this.route.snapshot.paramMap.get('token');
    this.apiService.verifyAccount(this.token, this.language).subscribe((res) => {
      this.result = res.data.accountVerified;
    }, (err) => {
      this.result = false;
    });
  }
}
